<template>
  <section>
    <z-form ref="form">
      <template slot="default">
        <backend-error />
        <z-form-input
          :rules="{ required: true, min: 6, max: 128, password: true }"
          :name="$t('core.reset_password.field.password')"
          vid="new_password"
          class="mb-3"
          :errors_absolute="false"
        >
          <label> {{ $t('core.reset_password.field.password') }} </label>
          <i-input
            v-model="form.password"
            :type="password_params.type"
            :disabled="is_successfully_changed"
          />
          <icon
            v-if="!!form.password"
            :type="password_params.icon"
            class="password-eye"
            size="20"
            @click="toggle_password"
          />
        </z-form-input>

        <z-form-input
          :rules="{ required: true, min: 6, max: 128, confirmed: '@new_password' }"
          vid="new_password_confirmation"
          class="mb-2"
          :errors_absolute="false"
        >
          <label>
            {{ $t('core.reset_password.field.confirm_password') }}
          </label>
          <i-input
            v-model="form.confirm_password"
            :type="confirm_password_params.type"
            :disabled="is_successfully_changed"
          />
          <icon
            v-if="!!form.confirm_password"
            :type="confirm_password_params.icon"
            class="password-eye"
            size="20"
            @click="toggle_confirm_password"
          />
        </z-form-input>
        <i-button
          :disabled="is_successfully_changed"
          type="primary"
          class="auth-content__form__submit mt-4"
          :loading="is_loading"
          @click="confirm_password"
        >
          {{ $t('core.reset_password.button.reset') }}
        </i-button>
        <template v-if="!is_successfully_changed">
          <link-to-auth-page />
        </template>
      </template>
    </z-form>

    <template v-if="is_successfully_changed">
      <div class="text-left reset-password-success mt-3">
        {{ $t('core.reset_password.success_change_password') }}
        <router-link :to="{ name: 'auth.login' }">
          {{ $t('core.reset_password.link.success_change_link_to_auth_page') }}
        </router-link>
      </div>
    </template>
  </section>
</template>

<script>
  import LinkToAuthPage from './reset-password-link-to-auth-page';
  import { ResetPasswordService } from '@core/services/ResetPasswordService';
  import BackendError from '@core/components/auth/auth-backend-error';

  export default {
    components: { BackendError, LinkToAuthPage },
    props: {
      email_code: {
        type: String,
        required: true
      }
    },
    data: () => ({
      form: {
        password: '',
        confirm_password: ''
      },
      password_params: {
        type: 'password',
        icon: 'md-eye'
      },
      confirm_password_params: {
        type: 'password',
        icon: 'md-eye'
      },
      is_loading: false,
      is_successfully_changed: false
    }),
    watch: {
      'form.password': {
        handler: function () {
          if (this.form.password == '') {
            this.password_params = {
              type: 'password',
              icon: 'md-eye'
            };
          }
        },
        deep: true
      },
      'form.confirm_password': {
        handler: function () {
          if (this.form.confirm_password == '') {
            this.confirm_password_params = {
              type: 'password',
              icon: 'md-eye'
            };
          }
        },
        deep: true
      }
    },

    methods: {
      show_error() {
        const wrong_password = this.$t('core.reset_password.error.wrong_password');
        this.$refs.form.setErrors({
          custom: wrong_password
        });
      },
      toggle_password() {
        this.password_params = {
          type: this.password_params.type === 'password' ? 'text' : 'password',
          icon: this.password_params.icon === 'md-eye-off' ? 'md-eye' : 'md-eye-off'
        };
      },
      toggle_confirm_password() {
        this.confirm_password_params = {
          type: this.confirm_password_params.type === 'password' ? 'text' : 'password',
          icon: this.confirm_password_params.icon === 'md-eye-off' ? 'md-eye' : 'md-eye-off'
        };
      },
      confirm_password() {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            const params = {
              email_code: this.email_code,
              new_password: this.form.password,
              new_password_confirmation: this.form.confirm_password
            };
            this.is_loading = true;
            ResetPasswordService.reset(params)
              .then(() => {
                this.is_successfully_changed = true;
              })
              .catch(() => {
                this.show_error();
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        });
      },
      
    }
  };
</script>
<style lang="scss">
  .reset-form-custom-error {
    position: relative;
    top: -15px;
  }
  .password-eye {
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 37px;
  }
</style>
